import { ActionTypes } from 'redux/utils/List'

export default ActionTypes('LAB_ORDER')